import React, { useState } from 'react';

const NewRAGAgentModal = ({ isOpen, onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    name: '',
    provider: 'AWS Bedrock',
    model: 'Claude 3 Sonnet',
    apiKey: '',
    region: 'us-east-1'
  });

  const providers = [
    { value: 'AWS Bedrock', label: 'AWS Bedrock' },
    { value: 'OpenAI', label: 'OpenAI' },
    { value: 'Google Cloud', label: 'Google Cloud Vertex AI' },
    { value: 'Azure OpenAI', label: 'Azure OpenAI' },
    { value: 'Anthropic', label: 'Anthropic' }
  ];

  const modelsByProvider = {
    'AWS Bedrock': ['Claude 3 Sonnet', 'Claude 3 Haiku', 'Llama 2'],
    'OpenAI': ['GPT-4', 'GPT-4 Turbo', 'GPT-3.5 Turbo'],
    'Google Cloud': ['PaLM 2', 'Gemini Pro'],
    'Azure OpenAI': ['GPT-4', 'GPT-3.5 Turbo'],
    'Anthropic': ['Claude 3 Opus', 'Claude 3 Sonnet', 'Claude 2']
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
    setFormData({
      name: '',
      provider: 'AWS Bedrock',
      model: 'Claude 3 Sonnet',
      apiKey: '',
      region: 'us-east-1'
    });
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="p-6 border-b border-gray-200">
          <div className="flex items-center justify-between">
            <h2 className="text-2xl font-bold text-gray-900">Create New RAG Agent</h2>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600"
            >
              <span className="text-2xl">×</span>
            </button>
          </div>
          <p className="text-sm text-gray-600 mt-1">Configure your RAG agent with LLM provider settings</p>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="p-6 space-y-6">
          {/* Agent Name */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Agent Name *
            </label>
            <input
              type="text"
              required
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="e.g., Customer Support Agent"
            />
          </div>

          {/* Provider Selection */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              LLM Provider *
            </label>
            <select
              value={formData.provider}
              onChange={(e) => setFormData({ 
                ...formData, 
                provider: e.target.value,
                model: modelsByProvider[e.target.value][0]
              })}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              {providers.map((provider) => (
                <option key={provider.value} value={provider.value}>
                  {provider.label}
                </option>
              ))}
            </select>
          </div>

          {/* Model Selection */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Model *
            </label>
            <select
              value={formData.model}
              onChange={(e) => setFormData({ ...formData, model: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              {(modelsByProvider[formData.provider] || []).map((model) => (
                <option key={model} value={model}>
                  {model}
                </option>
              ))}
            </select>
          </div>

          {/* API Key */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              API Key *
            </label>
            <input
              type="password"
              required
              value={formData.apiKey}
              onChange={(e) => setFormData({ ...formData, apiKey: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter your API key"
            />
            <p className="text-xs text-gray-500 mt-1">Your API key is encrypted and stored securely</p>
          </div>

          {/* Region (for AWS) */}
          {formData.provider === 'AWS Bedrock' && (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                AWS Region
              </label>
              <select
                value={formData.region}
                onChange={(e) => setFormData({ ...formData, region: e.target.value })}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="us-east-1">US East (N. Virginia)</option>
                <option value="us-west-2">US West (Oregon)</option>
                <option value="eu-west-1">EU (Ireland)</option>
                <option value="ap-southeast-1">Asia Pacific (Singapore)</option>
              </select>
            </div>
          )}

          {/* Info Box */}
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <p className="text-sm text-blue-800">
              <strong>💡 Tip:</strong> Make sure you have the necessary permissions and credits in your {formData.provider} account.
            </p>
          </div>

          {/* Actions */}
          <div className="flex justify-end gap-3 pt-4 border-t border-gray-200">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
            >
              Create RAG Agent
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default NewRAGAgentModal;
